export const app_navbar_routes = {
  auth: {},
  app: {
    expense: {
      root: "/expense",
      claim_expenses: "/expense/claim-expenses",
      advance_expenses: "/expense/advance-expenses",
      vendor_payments: "/expense/vendor-payments",
    },
  },
};
